/* ──────────────────────────────────────────────────────────────────────────
 * plant-sticky-cart.js
 * Reveals the mobile sticky bar when the hero scrolls away and pins it to
 * the visual viewport bottom (handles Chrome/Safari dynamic browser chrome).
 * Hides when the footer enters view so main padding does not leave a gap.
 * ──────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var main = document.querySelector('[data-template="product.plant"]');
  var bar = null;
  var rafId = null;
  var heroVisible = true;
  var footerVisible = false;

  function scheduleLayout() {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      layoutBar();
    });
  }

  /** Pin bar flush to the visible viewport bottom — no bottom-offset gap. */
  function layoutBar() {
    if (!bar) return;

    var vv = window.visualViewport;

    if (!vv) {
      bar.style.top = '';
      bar.style.bottom = '0';
      updateMainPadding();
      return;
    }

    var height = bar.getBoundingClientRect().height;
    var top = vv.offsetTop + vv.height - height;

    bar.style.bottom = 'auto';
    bar.style.top = Math.round(top) + 'px';
    updateMainPadding();
  }

  function updateMainPadding() {
    if (!bar || !main) return;

    if (bar.classList.contains('is-visible')) {
      main.style.setProperty('--plant-sticky-bar-height', bar.getBoundingClientRect().height + 'px');
    } else {
      main.style.setProperty('--plant-sticky-bar-height', '0px');
    }
  }

  function syncVariantInput() {
    var heroInput = document.querySelector('[data-buy-button-input]');
    var stickyInput = bar.querySelector('[data-plant-sticky-variant-id]');
    if (!heroInput || !stickyInput) return;

    stickyInput.value = heroInput.value;

    var heroForm = heroInput.closest('form');
    if (!heroForm) return;

    heroForm.addEventListener('change', function () {
      stickyInput.value = heroInput.value;
    });
  }

  function refreshVisibility() {
    var shouldShow = !heroVisible && !footerVisible;
    bar.classList.toggle('is-visible', shouldShow);
    scheduleLayout();
  }

  function init() {
    bar = document.querySelector('[data-plant-sticky-bar]');
    var hero = document.querySelector('.plant-hero');
    var footer = document.querySelector('footer');

    if (!bar) return;

    syncVariantInput();
    layoutBar();

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleLayout);
      window.visualViewport.addEventListener('scroll', scheduleLayout);
    }

    window.addEventListener('resize', scheduleLayout, { passive: true });
    window.addEventListener('scroll', scheduleLayout, { passive: true });

    if (footer && typeof IntersectionObserver !== 'undefined') {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            footerVisible = entry.isIntersecting;
            refreshVisibility();
          });
        },
        { threshold: 0, rootMargin: '0px 0px -1px 0px' }
      );
      footerObserver.observe(footer);
    }

    if (!hero) {
      heroVisible = false;
      refreshVisibility();
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      heroVisible = false;
      refreshVisibility();
      return;
    }

    var heroObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          heroVisible = entry.isIntersecting;
          refreshVisibility();
        });
      },
      { threshold: 0 }
    );

    heroObserver.observe(hero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
